module.exports = __webpack_public_path__ + "img/4.1.565e67c7.png";